import { useMutation } from '@tanstack/react-query';
import type { ParsedEvent } from '@/lib/types';
import { api } from '@/lib/api';

export function useParse() {
  return useMutation({
    mutationFn: (req: { content: string; contentType: string; weddingDate?: string; mimeType?: string }) =>
      api.post<{ events: ParsedEvent[]; count: number }>('/api/parse', req),
  });
}
